import React, { createContext, useContext, useState, useEffect } from 'react';
import { Appearance } from 'react-native';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(false); // Default to light mode

  // Remove automatic system theme detection to keep default light mode
  // useEffect(() => {
  //   // Get system theme preference
  //   const colorScheme = Appearance.getColorScheme();
  //   setIsDarkMode(colorScheme === 'dark');

  //   // Listen for system theme changes
  //   const subscription = Appearance.addChangeListener(({ colorScheme }) => {
  //     setIsDarkMode(colorScheme === 'dark');
  //   });

  //   return () => subscription?.remove();
  // }, []);

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };

  const theme = {
    isDarkMode,
    toggleTheme,
    colors: {
      // Light theme colors
      light: {
        primary: '#059669',
        secondary: '#3B82F6',
        background: '#FFFFFF',
        surface: '#F8FAFC',
        card: '#FFFFFF',
        cardBackground: '#FFFFFF',
        text: '#1F2937',
        textSecondary: '#6B7280',
        border: '#E5E7EB',
        success: '#10B981',
        warning: '#F59E0B',
        error: '#EF4444',
        info: '#3B82F6',
        accent: '#8B5CF6',
        gradient: ['#059669', '#047857'],
        shadow: 'rgba(0, 0, 0, 0.1)',
      },
      // Dark theme colors
      dark: {
        primary: '#4F46E5',
        secondary: '#60A5FA',
        background: '#0F172A',
        surface: '#1E293B',
        card: '#334155',
        cardBackground: '#1E293B',
        text: '#F1F5F9',
        textSecondary: '#CBD5E1',
        border: '#475569',
        success: '#22C55E',
        warning: '#F59E0B',
        error: '#EF4444',
        info: '#3B82F6',
        accent: '#8B5CF6',
        gradient: ['#4F46E5', '#3730A3'],
        shadow: 'rgba(0, 0, 0, 0.4)',
      }
    }
  };

  const currentColors = isDarkMode ? theme.colors.dark : theme.colors.light;

  return (
    <ThemeContext.Provider value={{ ...theme, colors: currentColors }}>
      {children}
    </ThemeContext.Provider>
  );
};